module.exports = __webpack_public_path__ + "static/media/icon-cargo-main.f184d1f8.svg";